import { TApplicationState } from 'shared/types/redux';

export const newbuildingUrlSelector = (state: TApplicationState): string => {
  return state.newbuilding.newbuildingPath;
};
